export default __webpack_public_path__ + "0e4f8177523e38f111dbb6642740c447.svg";